export const enSE = {
  app: {
    categories: {
      convectors: 'Convectors',
      decorative: 'Decorative',
      electric: 'Electric',
      panels: 'Panels',
      towel: 'Towel Warmers',
    },
    categoryLabel: 'Category',
    categoryPlaceholder: 'Select a category',
    errorCategories: 'Failed to load categories.',
    errorPanels: 'Failed to load radiators.',
    loadingCategories: 'Loading categories...',
    loadingPanels: 'Loading radiators...',
    panelLabel: 'Radiators',
    panelPlaceholder: 'Select a radiator',
    titles: {
      convectors: 'Convector Calculator',
      decorative: 'Designer Calculator',
      electric: 'Electric Radiator Calculator',
      panels: 'Panel Radiator Calculator',
      towel: 'Towel Warmer Calculator',
    },
  },
  calc: {
    actionButton: 'Show calculated items',
    boost: 'Boost mode',
    calculateRequiredButton: 'Calculate required watts',
    calculating: 'Calculating...',
    comfort: 'Comfort mode',
    downloadLabel: 'Download data ({count})',
    emptyResults: 'No results yet.',
    errorMatch: 'Failed to calculate results.',
    errorTypes: 'Failed to load radiator types.',
    flowTemp: 'Flow C°',
    height: 'Height',
    length: 'Length',
    loadingTypes: 'Loading types...',
    modeLabel: 'Mode',
    modes: {
      cooling: 'Cooling',
      heating: 'Heating',
    },
    radiatorType: 'Radiator type',
    requiredWatts: 'Required Watts',
    resultsMessage: '{count} items available for selected options.',
    returnTemp: 'Return C°',
    roomTemp: 'Room temperature C°',
    selectAllLabel: 'Select all items',
    selectItemLabel: 'Select item to download',
    selectPanel: 'Select a panel to calculate.',
    standby: 'Standby mode',
    tableHeaders: {
      calculatedWattage: 'Watts',
      co2Equivalent: 'CO2 Equivalent per kg or material',
      depth: 'Depth [mm]',
      description: 'Item Description',
      dop: 'DoP',
      eudop: 'EU DoP',
      height: 'Height [mm]',
      itemId: 'Item Code',
      length: 'Length [mm]',
      waterContent: 'Water Content',
      weight: 'Weight',
    },
    title: 'Calculations',
    tolerance: 'Tolerance',
    typeCooling: 'Cooling',
    typeGroupLabel: 'Type',
    typeHeating: 'Heating',
  },
  existingRadiator: {
    description:
      'This calculator is for information only. Always consult a professional installer for the exact calculation before purchasing the radiator.',
    height: 'Radiator Height',
    length: 'Radiator Length',
    resultLabelTemplate: 'Heat output requirement, calculated at {temp} system temperature',
    select: 'Select',
    temperature: 'System Temperature',
    type: 'Radiator Type',
  },
  matrixCalc: {
    axisHeight: 'Height (mm)',
    axisLength: 'Length (mm)',
    axisType: 'Type',
    calculateButton: 'Calculate',
    displayLabel: 'Display',
    exportExcel: 'Export as Excel',
    exportPdf: 'Export as PDF',
    print: 'Print',
    hideOutOfRange: 'Hide items out of range',
    showAll: 'Show all',
    loading: 'Loading...',
    lockHeight: 'Height',
    lockLabel: 'Lock dimension',
    lockLength: 'Length',
    lockType: 'Type',
    noData: 'Select a radiator and click Calculate to view the matrix.',
    noItem: '—',
    noType: '—',
    targetOutput: 'Target output (W)',
    title: 'Matrix Calculator',
    tolerance: 'Tolerance (%)',
  },
  roomCalc: {
    actionButton: 'Calculate',
    clearButton: 'Clear all',
    fields: {
      ceilingHeight: 'Ceiling height',
      doorInsulation: 'Door insulation',
      floorInsulation: 'Floor insulation',
      glazingArea: 'Glazing area',
      glazingMode: 'Glazing area',
      glazingQuality: 'Glazing quality',
      length: 'Length',
      outerWalls: 'Outer walls',
      projectedDesignTemp: 'Design outdoor temperature (DOT) where the building is located',
      roofInsulation: 'Roof insulation',
      roomArea: 'Room area',
      roomFloor: 'Storey',
      roomInsulation: 'Room insulation',
      roomPreset: 'Room preset',
      roomTemperature: 'Room temperature',
      roomType: 'Room type',
      uncertaintyFactor: 'Uncertainty factor',
      ventilation: 'Ventilation level',
      wallInsulation: 'Wall insulation',
      width: 'Width',
      windConditions: 'Wind conditions',
      windowInsulation: 'Window insulation',
    },
    intro:
      'Calculate the heat loss in the room to select the right product from our range of radiators.',
    options: {
      glazing: {
        m2: 'm²',
        percent: '%',
      },
      glazingBands: {
        high: 'More than 20%',
        low: 'Less than 10%',
        mid: '10-20%',
      },
      glazingValue: {
        above_20: 'Above 20%',
        below_10: 'Below 10%',
        from_10_to_20: 'From 10% to 20%',
        no_windows: 'Without windows',
      },
      insulationValue: {
        good: 'Good',
        medium: 'Medium',
        poor: 'Poor',
        very_good: 'Very good',
      },
      qualityValue: {
        modern_excellent: 'Modern, excellent energy efficiency',
        modern_good: 'Modern, good energy efficiency',
        old_poor: 'Old, very poor energy efficiency',
        traditional_medium: 'Traditional, medium energy efficiency',
      },
      roomValue: {
        bathroom_24: 'Bathroom (24 C°)',
        bedroom_20: 'Bedroom (20 C°)',
        garage_12: 'Garage (12 C°)',
        livingroom_22: 'Living room (22 C°)',
        storage_16: 'Storage (16 C°)',
      },
      select: 'Select',
      storeyValue: {
        ground_multi: 'Ground Floor',
        ground_single: 'Single storey',
        interim: 'Middle floor',
        top_multi: 'Top floor',
      },
      temp: {
        climate_zone_1: 'DUT -12 C°',
        climate_zone_2: 'DUT -14 C°',
        climate_zone_3: 'DUT -16 C°',
        climate_zone_4: 'DUT -18 C°',
        climate_zone_5: 'DUT -20 C°',
        climate_zone_6: 'DUT -22 C°',
        climate_zone_7: 'DUT -24 C°',
        climate_zone_8: 'DUT -26 C°',
      },
      windInfluence: {
        normal: 'Normal',
        strong: 'Strong',
        weak: 'Weak',
      },
    },
    roomPresets: {
      bathroom: 'Bathroom',
      bedroom: 'Bedroom',
      garage: 'Garage',
      kitchen: 'Kitchen',
      living: 'Living room',
      storage: 'Storage',
    },
    sections: {
      dimensions: 'Room dimensions',
      insulation: 'Insulation',
      placement: 'Placement',
      result: 'Result',
      temps: 'Temperatures',
      ventilation: 'Ventilation',
    },
    title: 'Room heat loss calculator',
    units: {
      celsius: 'C°',
      meter: 'm',
      percent: '%',
      squareMeter: 'm²',
      watts: 'W',
    },
    useButton: 'Use',
  },
  slider: {
    from: 'From',
    to: 'To',
    value: 'Value',
  },
}
